import type { RequestHistory } from '@main/dsr-types';
import type { DownloadZipProps } from '@main/privacy-center/src/hooks';
import React from 'react';

import { REQUEST_PREVIEWS } from './PREVIEWS';

/**
 * The RequestPreview props
 */
export interface RequestPreviewProps extends RequestHistory, DownloadZipProps {}

/**
 * The RequestPreview component
 */
function RequestPreview({ ...props }: RequestPreviewProps): JSX.Element {
  const StatusBlock = REQUEST_PREVIEWS[props.status];
  return <StatusBlock {...props} />;
}

export default RequestPreview;
